import moment from "moment"
import { ListType } from "../types"
import { APPROVAL, convertNumber, useApi, useToggle } from "utils"
import { ActionButton, Button, Modal, PermissionLink, TableNumber, TableSorting } from "components"
import { FillType } from ".."
import { IoSendSharp } from "react-icons/io5"
import { IoIosWarning } from "react-icons/io"
import { Fragment, useState } from "react"
import toast from "react-hot-toast"
import { Detail } from "../../../Transaction/AdjustmentInventory/components/Detail"
import { PERMISION } from "security"

export function TableBody(props: {
    index: number
    data: ListType
    pagination: FillType
    refetch: () => void
    tableActive: TableSorting[]
}) {
    return (
        <tr>
            <td>
                {TableNumber({
                    dataLength: props.pagination.limit,
                    pageCurrent: props.pagination.page,
                    index: props.index,
                    limit: props.pagination.limit,
                    totalData: props.pagination.total
                })}
            </td>

            {/* Kolom filter */}
            {props.tableActive
                .filter((col) => col.isActive !== false)
                .map((col, idx) => (
                    <Fragment key={idx}>
                        {renderCell(col.value!, props.data)}
                    </Fragment>
                ))}

            <td >
                <div className="flex gap-2">
                    {props.data.source === 2 && props.data.approve_status === APPROVAL.PENDING && (
                        <PermissionLink permission={PERMISION.INVENTORY.REGISTER.ADJUSTMENT.UPDATE} rel="noopener noreferrer" to={`/inventory/transaction/adjustment-inventory/edit/${props.data.adjustment_id}`} >
                            <IoSendSharp />
                        </PermissionLink>
                    )}

                    {props.data.source === 2 && props.data.approve_status !== APPROVAL.PENDING && (
                        <DetailAdjusment id={props.data.adjustment_id} />
                    )}

                    {props.data.source === 1 && (
                        <DetailAdjusment id={props.data.adjustment_id} />
                    )}

                    {APPROVAL.PENDING === props.data.approve_status &&
                        <Delete id={props.data.adjustment_id} refetch={props.refetch} />
                    }
                </div>
            </td>
        </tr >
    )
}

function Delete({
    id,
    refetch
}: {
    id: number,
    refetch?: () => void
}) {
    const api = useApi()
    const { isActive, toggle } = useToggle(false)
    const [isLoading, setIsLoading] = useState(false)

    const onDelete = () => {
        setIsLoading(true)
        return new Promise<void>((resolve) => {
            toast.promise(
                api.delete("/invadjustment/delete_inv_adjustment", { params: { adjustment_id: id } }),
                {
                    loading: "Loading...",
                    success: (res) => res.data.message,
                    error: (err) => err.response.data.message
                }
            ).then(() => {
                setIsLoading(false)
                toggle()
                refetch && refetch()
            }).catch(() => { }).finally(resolve)
        })
    }


    return (
        <>
            <ActionButton.Delete permission={PERMISION.INVENTORY.REGISTER.ADJUSTMENT.DELETE} onClick={toggle} />


            {isActive && (
                <Modal isOpen title="DELETE ITEM ADJUSTMENT" size="xl" closeModal={toggle}>
                    <h5 className="text-error ml-3">Are you sure want to delete this data?</h5>

                    <IoIosWarning className="mx-auto mt-5 text-[200px] text-primary" />

                    <Modal.Footer className="text-end">
                        <Button
                            type="submit"
                            color="error"
                            loading={isLoading ? "true" : undefined}
                            onClick={onDelete}
                        >
                            Delete
                        </Button>
                    </Modal.Footer>
                </Modal>
            )}
        </>

    )
}


function DetailAdjusment({ id }: { id: number }) {
    const { isActive, toggle } = useToggle(false)
    return (
        <>
            <Button
                permission={PERMISION.INVENTORY.REGISTER.ADJUSTMENT.READ}
                onClick={toggle}
            >
                <IoSendSharp />
            </Button>

            {isActive && (
                <Modal
                    isdarktitle
                    isOpen
                    title="DETAIL INVENTORY ADJUSTMENT"
                    closeModal={toggle}
                >
                    <Modal.Body>
                        <Detail adjustment_id={id.toString()} />
                    </Modal.Body>

                    <Modal.Footer>
                        <Button onClick={toggle}>CANCEL</Button>
                    </Modal.Footer>
                </Modal>
            )}
        </>
    )
}

function renderCell(value: string, item: ListType) {
    switch (value) {
        case "trx_code":
            return <td>{item?.trx_code}</td>
        case "count_code":
            return <td>{item?.count_code}</td>
        case "transaction_date":
            return <td>{moment(item?.transaction_date).format("DD/MM/YYYY")}</td>
        case "location_name":
            return <td>{item?.location_name}</td>
        case "employee_name":
            return <td>{item?.employee_name}</td>
        case "approve_status":
            return <td>{APPROVAL[item?.approve_status]}</td>
        case "memo":
            return <td>{item?.memo}</td>
        case "source":
            return <td>{item.source === 1 ? "COUNT ADJUSTMENT" : "DIRECT ADJUSTMENT"}</td>
        case "stock_in":
            return <td className="text-right">{item?.stock_in ? convertNumber(Number(item.stock_in)).intoNormalAmount : ""}</td>
        case "stock_out":
            return <td className="text-right">{item?.stock_out ? convertNumber(Number(item.stock_out)).intoNormalAmount : ""}</td>
        case "amount":
            return <td className="text-right">{item?.amount_adjustment ? convertNumber(Number(item.amount_adjustment)).intoCurrency : ""}</td>
        default:
            return <></>;
    }
}

